function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutline113X113Px = function SvgOutline113X113Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 113 113",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m64.3 4 45 47.6c3.4 3.6 3.3 9.3-.4 12.7l-47.6 45c-3.6 3.4-9.3 3.3-12.7-.4l-45-47.6C.2 57.7.3 52 4 48.6l47.6-45C55.2.2 60.9.3 64.3 4z",
    style: {
      fill: "none",
      stroke: "#e5e5e5",
      strokeWidth: 2
    }
  }));
};
export default SvgOutline113X113Px;